function formatPhoneNumber(phone: string) {

	if (!phone?.startsWith("+998") || phone.length !== 13) return phone;

  return (
    "+998 " +
    phone.slice(4, 6) +
    " " +
    phone.slice(6, 9) +
    " " +
    phone.slice(9, 11) +
    " " +
    phone.slice(11)
  );
}

export default formatPhoneNumber;
